//import images
import usFlag from "assets/images/flags/us.svg";
import spainFlag from "assets/images/flags/spain.svg";
import germanyFlag from "assets/images/flags/germany.svg";
import italyFlag from "assets/images/flags/italy.svg";
import russiaFlag from "assets/images/flags/russia.svg";
import chinaFlag from "assets/images/flags/china.svg";
import frenchFlag from "assets/images/flags/french.svg";
import aeFlag from "assets/images/flags/ae.svg";

export const languages = {
    en: {
        icon: usFlag,
        lable: "English",
        title: "English"
    },
    sp: {
        icon: spainFlag,
        lable: "Española",
        title: "Spanish"
    },
    gr: {
        icon: germanyFlag,
        lable: "Deutsche",
        title: "German"
    },
    it: {
        icon: italyFlag,
        lable: "Italiana",
        title: "Italian"
    },
    ru: {
        icon: russiaFlag,
        lable: "русский",
        title: "Russian"
    },
    ch: {
        icon: chinaFlag,
        lable: "中国人",
        title: "Chinese"
    },
    fr: {
        icon: frenchFlag,
        lable: "français",
        title: "French"
    },
    ar: {
        icon: aeFlag,
        lable: "عربى",
        title: "Arabic"
    },
}